import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BtwAvatar } from './BtwAvatar';
import { BtwText } from './BtwText';
import { Stack } from './Stack';
export const AvatarWithName = function AvatarWithName({ avatarUrl, name, variant, }) {
    return (_jsxs(Stack, { align: "center", direction: "row", gap: "1", children: [_jsx(AvatarNoTooltip, { avatarUrl: avatarUrl, size: "sm", userName: name }), _jsx(BtwText, { size: "xs", variant: variant, weight: "medium", children: name })] }));
};
export const AvatarNoTooltip = function AvatarNoTooltip({ avatarUrl, className, size, userName, }) {
    return (_jsxs(BtwAvatar.Root, { className: className, size: size, children: [_jsx(BtwAvatar.Image, { src: avatarUrl }), _jsx(BtwAvatar.Fallback, { children: userName.charAt(0) })] }));
};
